import {
    adminGetData,
    adminStore,
    kaprodiGetData,
    prodiGetPilihanData,
    kaprodiStore,
    update,
    destroy,
    setStatus,
    uploadExcel,
    getAllStudyCourses,
    getAllPiihanStudyCourses,
    getforprakrs,
    getforkrs,
    toggleStatus,
    toggleOpenStatus
} from '@/store/api/StudyCourseController'
import { 
    getAllData
} from '@/store/api/method'
const initialState = () => ({
    studyCourses: {last_page: 0,data: [], total: 0},
    autocompleteData: {},
    studyCourseList: [],
    response: {},
    request:{
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        search: null
    },
    recommendation: []
})
const state = initialState
const getters = {
    getStudyCourses: state => state.studyCourses,
    getResponse: state => state.response,
    getRequest: state => state.request,
    getAutocompleteData: state => state.autocompleteData,
    getStudyCourseList: state => state.studyCourseList,
    getRecommendation: state => state.recommendation || []
}

const actions = {
    async getRecommendationData({
        commit, state
    }, npm){
        try {
            const url = `/study-course/recommendation/${npm}`
            const response = await getAllData(url,state.request);
            commit('SET_RESPONSE', response.data);
            commit('SET_RECOMMENDATION_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getforkrs({commit}, request) 
    {
        try {
            state.request = request
            var response = await getforkrs(request);
      
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getforprakrs({commit}, request) 
    {
        try {
            state.request = request
            var response = await getforprakrs(request);
      
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async adminGetData({commit}, request) 
    {
        try {
            state.request = request
            var response = await adminGetData(request);
      
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async kaprodiGetData({commit}, request) 
    {
        try {
            state.request = request
            var response = await kaprodiGetData(request);
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async prodiGetPilihanData({commit}, request) 
    {
        try {
            state.request = request
            var response = await prodiGetPilihanData(request);
            commit('SET_DATA', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getAllStudyCourses({commit}) 
    {
        try {
            var response = await getAllStudyCourses();
            commit('SET_AUTOCOMPLETE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getAllPiihanStudyCourses({commit}) 
    {
        try {
            var response = await getAllPiihanStudyCourses();
            commit('SET_STUDY_COURSE_LIST', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async toggleStatus({commit}, id) 
    {
        try {
            var response = await toggleStatus(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async toggleOpenStatus({commit}, id) 
    {
        try {
            var response = await toggleOpenStatus(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async kaprodiStore({commit}, data) 
    {
        try {
            var response = await kaprodiStore(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async adminStore({commit}, data) 
    {
        try {
            var response= await adminStore(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async uploadExcel({commit }, data) 
    {
        try {
            var response = await uploadExcel(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async update({commit }, {data, id}) 
    {
        try {
            var response = await update(data, id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async setStatus({commit }, {data, id}) 
    {
        try {
            var response = await setStatus(data, id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async destroy({commit }, id) 
    {
        try {
            var response = await destroy(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    
}

const mutations = {
    SET_FAILED(state) {
        state.response = {
            msg: 'Jaringan Bermasalah',
            status: '0'
        }
    },
    SET_RESPONSE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
    },
    SET_RECOMMENDATION_DATA(state, value){
        state.recommendation = value
    },
    SET_FAILED_MESSAGE(state, error) {
        state.response.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.response.status = error?.data?.status || 0
    },
    SET_DATA(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.studyCourses = response.data
    },
    SET_AUTOCOMPLETE(state, response){
        state.autocompleteData = response.data
    },
    SET_STUDY_COURSE_LIST(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.studyCourseList = response.data
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}